import script from "./PublipostFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PublipostFormPage.vue?vue&type=script&setup=true&lang=js"

import "./PublipostFormPage.vue?vue&type=style&index=0&id=f82a0228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82a0228"]])

export default __exports__